import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      localStorage.setItem("yk_user", JSON.stringify(data));
      setUser(data);
    } catch (e) {
      const cached = !e?.response && localStorage.getItem("yk_user");
      setUser(cached ? JSON.parse(cached) : null);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return;
    checkAuth();
  }, [checkAuth]);

  const applyAuth = (data) => {
    if (data.token) localStorage.setItem("yk_token", data.token);
    localStorage.setItem("yk_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password, invitation_code) => applyAuth((await api.post("/auth/login", { email, password, invitation_code: invitation_code || undefined })).data);
  const register = async (payload) => applyAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.warn("logout", e?.message); }
    localStorage.removeItem("yk_user");
    localStorage.removeItem("yk_token");
    setUser(null);
  };
  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return <AuthCtx.Provider value={{ user, setUser, login, register, logout, googleLogin, applyAuth }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
